import { api } from '@/api'
import { AUTH_PUBLIC_ORIGIN_URL } from '@/env'

export interface AuthResponse {
  token: string
}

export interface MagicLinkRequestResponse {
  message: string
}

export const authService = {
  loginWithGoogleCode: (code: string, redirectUri: string) =>
    api.post<AuthResponse>('/auth/login/google', { code, redirectUri }),
  loginWithGoogleCredential: (credential: string) => api.post<AuthResponse>('/auth/login/google', { credential }),
  requestMagicLink: (email: string, inviteCode?: string | null) =>
    api.post<MagicLinkRequestResponse>('/auth/magic-link/request', {
      email,
      inviteCode: inviteCode || undefined,
      redirectUrl: `${AUTH_PUBLIC_ORIGIN_URL}/auth`
    }),
  verifyMagicLink: (token: string) => api.post<AuthResponse>('/auth/magic-link/verify', { token })
}
